<template>
  <div class="cardLedgerA">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :key="tableKey"
        :data="tableData"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        @on-load="getPage"
        @refresh-change="refreshChange"
        @sort-change="sortChange"
        @search-change="searchChange"
      >
        <template slot="menu" slot-scope="scope" class="menuSlot">
          <el-button
            type="text"
            v-if="
              permissions['chain:cardLedgerA:detail'] &&
              scope.row.waybillCount > 0
            "
            size="small"
            plain
            @click="detail(scope.row, scope.index)"
          >
            详情</el-button
          >
        </template>
        <template slot="menuLeft">
          <div class="tip">
            <i class="el-icon-info" style="color: #35B1FF;margin-right: 8px;"></i> 共查出A卡总数
            <span class="blue">{{ countForm.allCount }}</span> 张； 激活数
            <span class="blue">{{ countForm.activateCount }}</span> 张；
            未激活数
            <span class="blue">{{ countForm.unActivateCount }}</span> 张；
            已作废 <span class="blue">{{ countForm.voidCount }}</span> 张 
          </div>
        </template>
        <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-right: 20px;
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <el-button
              size="small"
              style="margin-right: 20px; margin-bottom: 0"
              @click="exOut"
            >
              导出
            </el-button>
            <span class="reset" @click="reset"> 重置筛选条件 </span>
          </div>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { getPage, getACardAccountCount } from "@/api/chain/cardLedgerA";
import { tableOption } from "@/const/crud/chain/cardLedgerA";
import { mapGetters } from "vuex";
import { exportOut } from "@/util/down.js";

export default {
  name: "cardLedgerA",
  data() {
    return {
      tableKey:0,
      form: {},
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: "binding_date", //降序字段
      },
      paramsSearch: {},
      tableLoading: false,
      tableOption: tableOption,
      countForm: {},
    };
  },
  created() {},
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  mounted: function () {
    // this.updateTableHeight(); // 页面加载时计算一次高度
    // window.addEventListener("resize", this.updateTableHeight);
    this.getACardAccountCount();
  },
  computed: {
    ...mapGetters(["permissions", "tagList"]),
    permissionList() {
      return {
        addBtn: this.permissions["chain:cardLedgerA:add"] ? true : false,
        delBtn: this.permissions["chain:cardLedgerA:del"] ? true : false,
        editBtn: this.permissions["chain:cardLedgerA:edit"] ? true : false,
        viewBtn: this.permissions["chain:cardLedgerA:get"] ? true : false,
      };
    },
  },
  methods: {
    updateTableHeight() {
        this.tableOption.height= this.$calculateTableHeight(
          this.$refs.crud.$refs.table
        )  
        this.tableKey += 1
    },
    search() {
      this.$refs.crud.searchChange;
    },
    reset() {
      this.$refs.crud.searchReset();
    },
    searchChange(params, done) {
      // debugger
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      // done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      if (params) {
        if (params.hasOwnProperty("searchDate")) {
          params.startDate = params.searchDate[0];
          params.endDate = params.searchDate[1];
          delete params.searchDate;
        }
      }
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    getACardAccountCount() {
      getACardAccountCount({}).then((res) => {
        this.countForm = res.data.data;
      });
    },
    detail(row) {
      let tag = this.findTag("/chain/business/companywaybill2").tag;
      if (tag) {
        this.$store.commit("DEL_TAG", tag);
      }
      console.log(this.tagList);
      this.$router.push({
        path: "/chain/business/companywaybill2",
        query: { statements: row.cardNo },
      });
    },
    findTag(url) {
      let tag, key;
      this.tagList.map((item, index) => {
        if (item.value.includes(url)) {
          tag = item;
          key = index;
        }
      });
      return { tag: tag, key: key };
    },
    exOut() {
      let params = Object.assign({}, this.paramsSearch);
      if (params) {
        if (params.hasOwnProperty("searchDate")) {
          params.startDate = params.searchDate[0];
          params.endDate = params.searchDate[1];
          delete params.searchDate;
        }
      }
      let url = "/chain/companycard/getACardAccountExport";
      exportOut(params, url, "A卡台账", "post");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.plTableBox .el-table td,
.plTableBox .el-table th.is-leaf {
  border-bottom: 1px solid #ededf0;
  background: #fff !important;
  font-weight: 400;
  font-size: 14px;
  color: #626266;
}
/deep/.el-table__header th.is-leaf {
  border: none;
  background: #F5F7FA;
  font-weight: 500;
  font-size: 14px;
  color: #313133;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: #fff;
}
.tip {
  margin-left: 16px;
  line-height: 40px;
  font-weight: 400;
  font-size: 14px;
  color: #313133;
  .blue {
    color: #35b1ff;
  }
}
/deep/.avue-crud__right {
  display: none;
}
.headerContent {
  margin-left: 75px;
  display: flex;
  align-items: center;

  // background: #F5F7FA;
  .label {
    margin-left: 8px;
  }
  .blue {
    color: #409eff;
  }
  .reset {
    font-weight: 400;
    font-size: 12px;
    color: #35b1ff;
    cursor: pointer;
  }
}
/deep/.el-collapse-item__wrap {
  // border: none;
  border-width: 15px;
  .avue-form__group--flex {
    padding-top: 16px;
    background: #F5F7FA;
  }
}
/deep/.avue-crud__menu {
  background: #F5F7FA;
  height: 40px;
  margin-bottom: 16px;
}
</style>
